import Core from "@/core/Core";
import RpcService from "@/core/services/Rpc/RpcService";

/**
 * Базовый класс для всех DAO (Data Access Object)
 * Предоставляет доступ к RPC сервису
 */
abstract class BaseDAO {
  /**
   * Ссылка на RPC сервис для выполнения запросов
   */
  static get rpc(): typeof RpcService {
    return Core.rpc;
  }
}

export default BaseDAO;
